export const checkIsEmptyDate = (date: string) => (!date ? true : date.replace(/-/g, '') === '');
